class LocalStorageHelper {
  static keys = Object.freeze({
    advancedOptionsOpen: "OutputHub:chartOptions:advancedOptionsOpen",
    beginYAxesAtZero: "OutputHub:chartOptions:beginYAxesAtZero",
    drawerMenuOpen: "OutputHub:drawerMenu:open",
    showAverageValue: "OutputHub:chartOptions:showAverageValue",
    /**
     * @deprecated Previously Used
     */
    showDashboardWelcomeDialog: "OutputHub:showDashboardWelcomeDialog",
    showOneRepMax: "OutputHub:chartOptions:showOneRepMax",
    showPersonalBest: "OutputHub:chartOptions:showPersonalBest",
    showStandardDeviation: "OutputHub:chartOptions:showStandardDeviation",
    /**
     * @deprecated Previously Used
     */
    showGroupDashboardOnBoardingTooltip: "OutputHub:dashboards:showGroupDashboardOnBoardingTooltip",
    /**
     * @deprecated Previously Used
     */
    showPredefinedVelocityTargetsOnBoardingTooltip: "OutputHub:workouts:showPredefinedVelocityTargetsOnBoardingTooltip",
    /**
     * @deprecated Previously Used
     */
    showDashboardReportsOnBoardingTooltip: "OutputHub:dashboards:showDashboardReportsOnBoardingTooltip",
    profileLocale: "OutputHub:profile:locale",
    /**
     * To make a unique key for each user we need to add the userId to the key, **OutputHub:hasRequestedCancellation:user.uid"**
     */
    hasRequestedCancellation: "OutputHub:hasRequestedCancellation",
    /** Stores the last viewed entity (athlete or group) in the calendar feature */
    calendarLastViewedEntity: "OutputHub:calendar:lastViewedEntity",
    programInProgressWarningDismissed: "OutputHub:programming:inProgressWarningDismissed",
    showCircuitsOnBoardingTooltip: "OutputHub:library:showCircuitsOnBoardingTooltip",
    /**
     * Whether an upgrade has already been requested for a gated feature. Suffixed
     * with the feature, e.g. **OutputHub:upsell:accessRequested:OutputProgram**, so
     * Output Program and Groups & Monitoring are tracked independently.
     */
    upsellAccessRequested: "OutputHub:upsell:accessRequested",
    /**
     * @deprecated Previously Used
     */
    showSensorUpsellOnBoardingTooltip: "OutputHub:sensor:showSensorUpsellOnBoardingTooltip",
    /**
     * Whether the 'New' tag is visible as part of the Sensor Upsell Announcement.
     * @deprecated Previously Used
     */
    showSensorUpsellAnnouncementTag: "OutputHub:sensor:showSensorUpsellAnnouncementTag",
    /**
     * @deprecated Previously Used
     */
    showSensorUpsellBanner: "OutputHub:sensor:showSensorUpsellBanner",
    /**
     * Day-scoped AI Performance Summary cache. Suffixed with the summary's scope key (dashboard
     * id, filters, widget config — not the calendar day, which is checked against the cached
     * response's own `generatedAt` instead), e.g.
     * **OutputHub:performanceSummary:aiSummary:&lt;scopeKey&gt;**.
     */
    aiPerformanceSummary: "OutputHub:performanceSummary:aiSummary",
    /**
     * The renewal date (YYYY-MM-DD) the Upcoming Renewal banner was dismissed for, so it
     * stays hidden for that renewal until it is within 7 days and no longer dismissible.
     */
    upcomingRenewalBannerDismissal: "OutputHub:subscription:upcomingRenewalBannerDismissal",

    // velocity based flags
    showDashboardVelocityModal: "OutputHub:onboarding:showDashboardVelocityModal",
    showDashboardVelocityHotspot: "OutputHub:onboarding:showDashboardVelocityHotspot",
    showAthleteVelocityHotspot: "OutputHub:onboarding:showAthleteVelocityHotspot",
    showAthleteVelocityModal: "OutputHub:onboarding:showAthleteVelocityModal",
    showAthleteProfilingVelocityHotspot: "OutputHub:onboarding:showAthleteProfilingVelocityHotspot",
    showAthleteProfilingVelocityTooltip: "OutputHub:onboarding:showAthleteProfilingVelocityTooltip",
    showAthleteOneRepMaxVelocityHotspot: "OutputHub:onboarding:showAthleteOneRepMaxVelocityHotspot",
    showAthleteOneRepMaxVelocityTooltip: "OutputHub:onboarding:showAthleteOneRepMaxVelocityTooltip",
    //
  });

  /**
   * @param {string} keyName
   * @param {null | boolean | undefined} defaultValue
   */
  static get(keyName, defaultValue = null) {
    return JSON.parse(localStorage.getItem(keyName) || defaultValue);
  }

  static set(keyName, keyValue) {
    return localStorage.setItem(keyName, keyValue ?? null);
  }
}
export default LocalStorageHelper;
